import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "navbar" }
const _hoisted_3 = { class: "navbar-container" }
const _hoisted_4 = { class: "navbar-nav" }
const _hoisted_5 = { class: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("a", {
          href: "/",
          class: "navbar-brand"
        }, [
          _createElementVNode("span", { class: "brand-icon" }, "🏋️‍♀️"),
          _createElementVNode("span", { class: "brand-text" }, "减简")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "nav-link"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "link-icon" }, "📊", -1),
              _createElementVNode("span", { class: "link-text" }, "概览", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/weight",
            class: "nav-link"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "link-icon" }, "⚖️", -1),
              _createElementVNode("span", { class: "link-text" }, "体重记录", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/food",
            class: "nav-link"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("span", { class: "link-icon" }, "🍎", -1),
              _createElementVNode("span", { class: "link-text" }, "饮食记录", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/exercise",
            class: "nav-link"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "link-icon" }, "🏃‍♂️", -1),
              _createElementVNode("span", { class: "link-text" }, "运动记录", -1)
            ])),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_5, [
      _createVNode(_component_router_view)
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("footer", { class: "footer" }, [
      _createElementVNode("div", { class: "footer-container" }, [
        _createElementVNode("p", null, "© 2026 减简 | 健康生活，从记录开始")
      ])
    ], -1))
  ]))
}